<template>
    <div class="px-6 py-10">
        <router-view></router-view>
    </div>
</template>

<script setup>

</script>
